import { Suspense, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { ErrorStateFallback } from '@/components/ui/error-state';
import { useJobPostingContext } from '@/contexts/job-posting-context';

import { Header } from './header';
import { STEP_CONTENT_WIDTH } from './header/step-config';
import { JobPostingFlow } from './job-posting-flow';
import { PostingPage } from './posting-result';

export function JobPosting() {
  const location = useLocation();
  const { handlePostJob, clearJobPostingStorage } = useJobPostingContext();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    void handlePostJob();
  };

  // Clear storage when user navigates away from /post-job route. This won't trigger on page refresh since the component remounts with the same location
  useEffect(() => {
    return () => {
      if (!window.location.pathname.includes('/post-job')) {
        clearJobPostingStorage();
      }
    };
  }, [location, clearJobPostingStorage]);

  return (
    <ErrorStateFallback>
      <form onSubmit={handleSubmit}>
        <div className="flex h-screen flex-col gap-4">
          <Header />

          <JobPostingFlow />
        </div>
      </form>
    </ErrorStateFallback>
  );
}

/** `/post-job/:bulkPostId`: the result step's layout around one posting batch. */
export function JobPostingBatch() {
  return (
    <div className="flex h-screen flex-col gap-4">
      <Header isPostingPage />

      <div className="flex flex-1 overflow-hidden">
        <div className="flex w-full px-4 lg:gap-4">
          <main className="flex w-full min-w-0 flex-col items-center gap-3 overflow-y-auto pb-6 lg:flex-1">
            <div
              className={`flex w-full flex-col gap-3 ${STEP_CONTENT_WIDTH.result}`}
            >
              <ErrorStateFallback>
                <Suspense fallback={<PostingPage.Skeleton />}>
                  <PostingPage />
                </Suspense>
              </ErrorStateFallback>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
